import { render, staticRenderFns } from "./ItemGallery.vue?vue&type=template&id=1d4551b6&"
import script from "./ItemGallery.vue?vue&type=script&lang=js&"
export * from "./ItemGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports